/* Promo banner (Oct 2026). snippets/promo-banner.liquid prints the banner(s); pages can be cached, so this shows the
   first banner whose start/end window is open on the visitor's clock, hides the rest, and runs the countdown.
   The countdown only shows in the last data-window seconds (countdown_days, default 5 days); before that the banner
   reads "Ends <date>". The countdown is aria-hidden; screen readers read the static "Ends <date>" text instead.
   Reduced motion: minutes only, updated every 30 s.
   Cart page: a banner that depends on the cart (items or subtotal) re-renders itself through the Section Rendering
   API after a cart change (Dawn pub/sub `cartUpdate`; other carts can call window.ArtikaPromoBanner.refresh()). */
(() => {
  if (window.ArtikaPromoBanner) return;
  const still = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = (n) => String(n).padStart(2, '0');
  const tick = () => {
    const now = Date.now() / 1000;
    document.querySelectorAll('[data-promo-banners]').forEach((wrap) => {
      let shown = null;
      wrap.querySelectorAll('[data-promo-banner]').forEach((b) => {
        const s = +b.dataset.starts || 0;
        const e = +b.dataset.ends || 0;
        b.hidden = !!shown || now < s || (e > 0 && now >= e);
        if (!b.hidden) shown = b;
      });
      const t = shown && shown.querySelector('[data-promo-timer]');
      if (!t) return;
      const left = Math.floor(+t.dataset.to - now);
      const label = shown.querySelector('[data-promo-ends]');
      const win = +t.dataset.window || 432000;
      if (left <= 0 || left > win) { t.hidden = true; label.classList.remove('is-sr'); return; }
      const [d, h, m, s] = (t.dataset.units || 'd h m s').split(' ');
      const D = Math.floor(left / 86400), H = Math.floor(left / 3600) % 24, M = Math.floor(left / 60) % 60;
      t.lastElementChild.textContent = (D ? `${D} ${d} ` : '') + `${pad(H)} ${h} ${pad(M)} ${m}` + (still ? '' : ` ${pad(left % 60)} ${s}`);
      t.hidden = false;
      label.classList.add('is-sr');
    });
  };
  const refresh = () => {
    document.querySelectorAll('[data-promo-banners][data-section-id]').forEach(async (wrap) => {
      const id = wrap.dataset.sectionId;
      try {
        const res = await fetch(`${location.pathname}?section_id=${encodeURIComponent(id)}`);
        if (!res.ok) return;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-promo-banners]');
        if (fresh) wrap.replaceChildren(...fresh.childNodes);
        else wrap.replaceChildren();
        tick();
      } catch (e) { /* keep the current banner */ }
    });
  };
  // "See full terms": open the offer details lightbox; close on the X or a click on the backdrop (Esc is native).
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-promo-terms]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.promoTerms);
      if (dialog && dialog.showModal) { e.preventDefault(); dialog.showModal(); }
      return;
    }
    const dialog = e.target.closest('dialog.promo-terms');
    if (dialog && (e.target === dialog || e.target.closest('[data-promo-terms-close]'))) dialog.close();
  });
  window.ArtikaPromoBanner = { refresh };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
  }
  tick();
  setInterval(tick, still ? 30000 : 1000);
})();
